import React from 'react';
import i18n from '../../i18n/i18n.js';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { ReactSVG } from "react-svg";

import './AppDiscounts.css'; 

class AppDiscounts extends React.Component {

  fakeMessages = [
    {
      id: 1,
      title: 'Ingyenes szállítás havi 1 alkalommal, ha az appon keresztül vásárol.',
      date: '2024.04.26',
      image: 'assets/images/demo/appdiscount.png',
      new: 1,
      content: "<p><b style=\"font-size: 21px;\">Kupon kód: DFR33456</b></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc luctus purus sed justo convallis congue.</p><p>In sit amet posuere libero, in dictum felis. Fusce vehicula dui quis erat pretium, vitae finibus nibh suscipit.</p>"
    },
    {
      id: 2,
      title: 'Kedvezmény kuponod érkezett!',
      date: '2024.04.26',
      image: 'assets/images/demo/appdiscount.png',
      new: 1,
      content: "<p><b>Kupon kód: DFR33456</b></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc luctus purus sed justo convallis congue.</p><p>In sit amet posuere libero, in dictum felis. Fusce vehicula dui quis erat pretium, vitae finibus nibh suscipit.</p>"
     },
    {
      id: 3,
      title: 'Kedvezmény kuponod érkezett!',
      date: '2024.04.26',
      image: 'assets/images/demo/appdiscount.png',
      new: 0,
      content: "<p><b>Kupon kód: DFR33456</b></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc luctus purus sed justo convallis congue.</p><p>In sit amet posuere libero, in dictum felis. Fusce vehicula dui quis erat pretium, vitae finibus nibh suscipit.</p>"
    },
  ];

  constructor(props) {
      super(props);

      this.state = {
        message_id: 0,
        messages: [...this.fakeMessages],
        hiding: false,
        show: 0,
      }
  }

  show() {
    this.setState({show: true});
  }

  hide() {
    this.setState({hiding: true}, function() {
      setTimeout(() => {
        this.setState({show: false, hiding: false});
      }, 200);
    });
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show();
    }
  }

  setMessageId(message_id) {
    this.setState({message_id: message_id},()=>{this.show()});
  }

  render() {
    const { message_id, messages, show, hiding } = this.state;

    if (!show) return '';

      let selected_message = {};
      let class_name = 'msg1'; 

      if (!!message_id)
      {
        selected_message = messages.filter((message) => message.id === message_id)[0];
        class_name = 'msg2';
      }


      return <div
        className={`container page_app_discounts ${hiding ? 'out' : ''} ${class_name}`}>
        <div className="content">
        
          <PageHeader parent_ref={this} no_close title={i18n.t('appDiscountsTitle')} />
          
          <div className='container_inner'>
            {parseInt(message_id) === 0 ? <>
              {messages.map((message) => 
                <div key={message.id} className={`list_item_badge ${!message.new ? 'opened' : ''}`} onClick={() => {window.modals.AppDiscountsRef_2.current.setMessageId(message.id)}}>
                  <div className="left">
                    <label>{message.title}</label>
                    <div className="date">{message.date}</div>
                  </div>
                  <ReactSVG className="right" src="assets/images/arrow_down.svg" />
                </div>
              )}
            </>
            : <>
                {<div key={"d_"+message_id} className="selected_message">
                  <h3>{selected_message.title}</h3>
                  <div className="date">{selected_message.date}</div>
                  <img src={selected_message.image} />
                  <div className="content" dangerouslySetInnerHTML={{__html: selected_message.content}}></div>
                </div>}
              </>
            }
          </div>

        </div>
      </div>;

  }
}

export default AppDiscounts;

